"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = exports.set = void 0;
//@TODO #Refactor #Correct
//This is incomplete, we planed to wrap get/set for handling app version
// No code realted to app version check or deleting item based n that check
var set = function (key, value) {
    return localStorage.setItem(key, JSON.stringify(value));
};
exports.set = set;
var get = function (key, toJson) {
    if (toJson === void 0) { toJson = true; }
    var value = localStorage.getItem(key);
    if (toJson) {
        value = JSON.parse(value);
    }
    return value;
};
exports.get = get;
